import React from "react";
import type { GetStaticPropsContext, NextPage } from "next";
import { useRouter } from "next/router";

import JoinRemax from "shared/components-pages/unete/JoinRemax";
import Statistic from "shared/components-pages/unete/Statistic";
import Motivation from "shared/components-pages/unete/Motivation";
import HeadMeta, { IHeadMetaComponent } from "shared/components/head-meta";
import { CKeyWordsPages } from "shared/models/const/keywords.const";

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`../../lang/${locale}.json`)).default,
    },
  };
}

const Unete: NextPage = () => {
  const router = useRouter();

  const metaData: IHeadMetaComponent = {
    description: "join",
    keyWords: CKeyWordsPages.join,
    title: "join",
    url: router.asPath,
    picture:
      "/images/image-optimize/happy-couple-with-keys-of-new-apartment.webp",
  };

  return (
    <>
      <HeadMeta {...metaData} />
      <JoinRemax />
      <Statistic />
      <Motivation />
    </>
  );
};

export default Unete;
